<template>
  <div class="announcements">
    <h3>Announcements</h3>
    <!--Date-->
    <div class="date" v-if="announcements">
      <div class="col-2">
        <label for="date" class="date-label">Date</label>
      </div>
      <div class="col-4">
        <input type="text" class="form-control" id="date" v-model="announcements[0].datetime" />
      </div>
    </div>
    <!--/Date-->

    <!--items-->
    <div class="items">
      <div class="item" v-for="(item, index) in announcements" v-bind:key="index">
        <div class="row">
          <div class="col-2 icons">
            <button class="btn btn-primary btn-circle btn-md updown" :disabled="index == 0" @click="moveUp(index)">
              <font-awesome-icon icon="chevron-up"></font-awesome-icon>
            </button>
            <button class="btn btn-primary btn-circle btn-md updown"  :disabled="index == (announcements.length - 1)" @click="moveDown(index)">
                <font-awesome-icon icon="chevron-down"></font-awesome-icon>
            </button>
          </div>
          <div class="col-9">
            <span class="labels">Title (Required)</span>
            <input type="text" class="form-control title" v-model="item.title" />
            <span class="labels">Details</span>
            <textarea name="details" class="form-control details" rows="10" v-model="item.details"></textarea>
            <!-- <span class="labels">Image Link</span>
            <input type="text" class="form-control link" v-model="item.image" placeholder="link to image" /> -->
            <span class="labels">Link</span>
            <input type="text" class="form-control link" v-model="item.link" placeholder="link to meeting, resource etc." />
            <span class="labels">Link Title</span>
            <input type="text" class="form-control linkTitle" v-model="item.linkTitle" placeholder="title of the button displayed in app"/>
          </div>
          <div class="col-1 icons">
            <button class="btn btn-primary btn-circle btn-md" @click="removeItem(index)">
              <font-awesome-icon icon="minus"></font-awesome-icon>
            </button>
          </div>
        </div>
        <hr />
      </div>
    </div>

    <div class="add">
      <div class="row">
        <div class="col-10">
          <button class="btn btn-primary" :disabled="submitted" @click="submitItems">
            Submit
            <font-awesome-icon icon="circle-notch" class="fa-spin" v-if="submitted"></font-awesome-icon>
          </button>
          <div class="col-12 alert alert-danger" v-if="error">{{error}}</div>
          <div class="col-12 alert alert-success" v-if="success">{{success}}</div>
        </div>
        <div class="col-2">
          <button class="btn btn-primary btn-circle btn-xl" @click="addItem">
            <font-awesome-icon icon="plus"></font-awesome-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAnnouncements, setAnnouncements } from "../db.js";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "Announcements",
  components: {
    FontAwesomeIcon
  },
  data() {
    return {
      submitted: false,
      success: "",
      error: "",
      announcements: null
    };
  },
  async created() {
    let loader = this.$loading.show({
      color: '#00407c'
    });
    const result = await getAnnouncements();
    this.announcements = result.val();
    loader.hide();
  },
  methods: {
    addItem() {
      this.announcements.push({
        datetime: "",
        title: "",
        details: "",
        link: "",
        linkTitle: ""
      });
    },
    removeItem(index) {
      this.announcements.splice(index, 1);
    },
    moveUp(i){
      if (i == 0) return;

      let loader = this.$loading.show({
      color: '#00407c'
      });

      const newIndex = i-1;
      const oldIndex = i;
      const temp = this.announcements[newIndex];

      this.$set(this.announcements, newIndex, this.announcements[oldIndex]);
      this.$set(this.announcements, oldIndex, temp);

      loader.hide();
    },
    moveDown(i){
      const last =  this.announcements.length - 1;
      if (i == last) return;

      let loader = this.$loading.show({
      color: '#00407c'
      });

      const newIndex = i+1;
      const oldIndex = i;
      const temp = this.announcements[newIndex];

      this.$set(this.announcements, newIndex, this.announcements[oldIndex]);
      this.$set(this.announcements, oldIndex, temp);
      
      loader.hide();
    },
    submitItems() {
      this.submitted = true;
      const filtered = this.announcements.filter(
        i => i.title !== "" && i.details !== ""
      );
      const withDate = filtered.map((i) => { 
          return { ...i, datetime: this.announcements[0].datetime }
      });
      setAnnouncements(withDate)
        .then(() => {
          this.submitted = false;
          this.success = "Announcements uploaded succesfully";
          this.resetMessage();
        })
        .catch(err => {
          this.submitted = false;
          this.error = "An error occured uploading.";
          this.resetMessage();
        });
    },
    resetMessage() {
      setTimeout(() => {
        this.success = "";
        this.error = "";
      }, 5000)
    }
  }
};
</script>
<style lang="scss" scoped>
.date-label {
  font-weight: 700;
}
.date {
  margin: 25px 0;
}
.labels {
  font-weight: 600;
  margin: 10px 0;
}
.item {
  margin-bottom: 30px;
}
.icons {
  display: flex;
  align-items: center;
}
</style>